export default {
  PARENT: 'parent',
  CHILDREN: 'children',
  STUDENT: 'student',
  TEACHER: 'teacher',
  NONE: 'none',
};
